import i18n from '@/i18n';

export const locales = {
  ZH_CN: {
    copyright: 'Copyright © 1998 - 2024 Tencent. All Rights Reserved.',
    privacy: i18n.t('隐私保护声明'),
    serviceTerm: i18n.t('服务协议'),
    cookiePolicy: i18n.t('Cookie协议'),
  },
  EN: {
    copyright: 'Copyright © 2024 Hong Kong Gathering Media Limited. All Rights Reserved.',
    privacy: 'Privacy Policy',
    serviceTerm: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
  },
};
